import { Table, Tooltip } from 'antd';
import AntdTable from 'components/AntdTable';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useModalConfirm from 'hook/useModalConfirm';
import { TooltipHide } from 'page/Application/ManageCompanyList/CompanyList/styled';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useMultiLanguageFileDownloadLog from '../hook/useMultiLanguageFileDownloadLog';

const AccountsFileDownloadRankingTable = ({
  dataRaw,
  isLoading,
  emptyText,
}) => {
  const navigate = useNavigate();

  const {
    FILE_DOWNLOAD_LOG_TABLE_ID,
    FILE_DOWNLOAD_LOG_TABLE_COUNT,
    FILE_DOWNLOAD_LOG_TABLE_ACCOUNT_EMAIL
  } = useMultiLanguageFileDownloadLog();

  const { contextHolder } = useModalConfirm();
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();

  const columns = useMemo(() => {
    return [
      Table.SELECTION_COLUMN,
      {
        key: 'rank',
        title: (
          <TooltipHide>
            <Tooltip
              title={FILE_DOWNLOAD_LOG_TABLE_ID}
              placement={'topLeft'}
            >
              {FILE_DOWNLOAD_LOG_TABLE_ID}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'rank',
        align: 'left',
        width: 120,
        render: (rank) => (
          <TooltipHide>
            <Tooltip title={rank} placement={'topLeft'}>
              {rank}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'email',
        title: (
          <TooltipHide>
            <Tooltip
              title={FILE_DOWNLOAD_LOG_TABLE_ACCOUNT_EMAIL}
              placement={'topLeft'}
            >
              {FILE_DOWNLOAD_LOG_TABLE_ACCOUNT_EMAIL}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'email',
        align: 'left',
        ellipsis: true,
        render: (email) => (
          <TooltipHide>
            <Tooltip title={email} placement={'topLeft'}>
              {email}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'count',
        title: (
          <TooltipHide>
            <Tooltip
              title={FILE_DOWNLOAD_LOG_TABLE_COUNT}
              placement={'topLeft'}
            >
              {FILE_DOWNLOAD_LOG_TABLE_COUNT}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'count',
        align: 'left',
        width: 90,
        render: (count) => (
          <TooltipHide>
            <Tooltip title={count?.toLocaleString()} placement={'topLeft'}>
              {count?.toLocaleString()}
            </Tooltip>
          </TooltipHide>
        ),
      },
    ];
  }, [navigate, isOnline, errorNetWork]);

  // format data for render table
  const dataSource = useMemo(() => {
    if (isLoading && !dataRaw) return [];
    return dataRaw?.list?.map((item) => ({
      ...item,
      key: item.rank,
    }));
  }, [dataRaw, isLoading]);


  return (
    <>
      {contextHolder}
      {contextErrorNetWork}
      <AntdTable
        columns={columns}
        isLoading={isLoading}
        dataSource={dataSource}
        emptyText={emptyText}
      />
    </>
  );
};

export default AccountsFileDownloadRankingTable;
